import { useContext } from 'react';
import { PermissionsContext } from '../contexts/complexContexts';

export const usePermissions = () => {
  const context = useContext(PermissionsContext);
  if (!context) {
    throw new Error('usePermissions must be used within PermissionsProvider');
  }
  return context;
};